import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner contact">
			    <div className="Banner_Content">
					<Container fluid>
						<h1 className="wow fadeInUp">JOB APPLICATION</h1>
						<div className="red-border"> </div>
						<p>digiPanda is looking for smart, intelligent and awesome people to join our global workforce for a challenging & rewarding career.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
